import { compact, find, map } from 'lodash';
import { v4 as uuid } from 'uuid';
import { formatEpochAsDateTime } from '../../util/datetime';
import { getTrail, removeTrail, toUUID } from '../../util/transform';
import { DocType } from '../global/Doc.enum';
import Root from '../Root';
import { DocumentType } from './Document.enum';
import type { IDocument } from './Document.interface';

export default class Document extends Root implements IDocument {
  idOwnerContact: string;
  idOwnerPartner: string;
  idLabels: Array<string>;
  name: string;
  file: string;
  fields: Array<string>;
  pdfFields: Array<any>;
  isCompliance: boolean;
  isShared: boolean;
  isSharedPartner: boolean;
  isLocked: boolean;
  isPinned: boolean;

  getName() {
    return this.name;
  }

  getNameWithoutExtension() {
    return removeTrail(this.getName(), getTrail(this.getName(), '.', true));
  }

  getFile() {
    return this.file;
  }

  getFileExtension() {
    return getTrail(this.getFile(), '.');
  }

  getType() {
    return find(
      DocumentType.available(),
      (obj) =>
        obj?.extensions.split(',').indexOf(String(this.getFileExtension()).toLowerCase()) > -1
    );
  }

  getDateTime(timeZone, locale, localeFormat) {
    return formatEpochAsDateTime(this.timeStamp, timeZone, locale, localeFormat);
  }

  getDateSort() {
    return this.timeStamp;
  }

  static build = (data: IDocument) => new Document(data);
  static blank = () => new Document({ id: uuid(), isActive: true });

  /**
   * Constructor
   * @param {IDocument} data
   */
  constructor(data?: IDocument) {
    super(DocType.of('__definition.document'), data);

    this.idOwnerContact = toUUID(data?.idOwnerContact);
    this.idOwnerPartner = toUUID(data?.idOwnerPartner);
    this.idLabels = compact(map(data?.idLabels, (obj) => toUUID(obj)));
    this.name = data?.name || '';
    this.file = data?.file || '';
    this.fields = data?.fields || [];
    this.pdfFields = data?.pdfFields || [];
    this.isCompliance = data?.isCompliance === true;
    this.isShared = data?.isShared === true;
    this.isSharedPartner = data?.isSharedPartner === true;
    this.isLocked = data?.isLocked === true;
    this.isPinned = data?.isPinned === true;
  }
}
